import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { Button, Typography } from "@material-ui/core";
import ListAltIcon from "@mui/icons-material/ListAlt";

export default function MonitoramentoPrecoHeader({ classes }) {
  const history = useHistory();

  const handleHistoricoColetas = () => {
    history.push("/admin/historico-coletas-monitoramento-preco");
  };

  return (
    <header className={classes.topBar}>
      <div className={classes.titleBlock}>
        <Typography component="h1" className={classes.titleMain}>
          Coleta de Preços – Loja Física
        </Typography>
        <p className={classes.subtitle}>
          Registre os preços dos produtos das marcas e dos concorrentes encontrados
          na loja.
        </p>
      </div>
      <Button
        variant="outlined"
        color="primary"
        className={classes.minhasColetasBtn}
        startIcon={<ListAltIcon />}
        onClick={handleHistoricoColetas}
      >
        Minhas coletas
      </Button>
    </header>
  );
}

MonitoramentoPrecoHeader.propTypes = {
  classes: PropTypes.object.isRequired,
};
